import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { AccordionItemMixin } from '../../mixins/components/AccordionItemMixin';
export var StyledAccordionItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "StyledAccordionItem",
  componentId: "c11n-8-64-0__sc-1bjy1ej-0"
})(["", ""], AccordionItemMixin);
/**
 * The `Accordion.Item` component is used by the
 * [`Accordion`](#/More%20components?id=accordion) component.
 *
 * **This component should not be used on its own.**
 *
 * @since 8.43.0
 */

var AccordionItem = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledAccordionItem, _extends({
    ref: forwardedRef
  }, props));
});
AccordionItem.propTypes = {
  children: PropTypes.node.isRequired
};
AccordionItem.displayName = 'Accordion.Item';
/** @component */

export default AccordionItem;